import Clock from "./clock";
import EventLoop from "./event-loop";
import LoadTimeline from "./load-timeline";
import TrainingService from "../service";

class TrainingPlayer {
    training;
    eventLoop;
    clock;
    promise;
    currentChapterId;

    static TIME_RESOLUTION = 40;

    constructor(training, chapterId) {
        this.training = training;
        this.eventLoop = new EventLoop(training);
        this.clock = new Clock(async dt => await this.tick(dt), TrainingPlayer.TIME_RESOLUTION);
        this.promise = {
            resolve: null,
            reject: null,
            running: false
        };
        this.currentChapterId = chapterId;
    }

    async playModule(chapterId) {
        StepInstructionScreenManager.removeScreen();
        if (this.promise?.running) {
            throw new Error('A chapter is currently playing');
        }

        if (wv.effectController.stoppedTrainingId === this.training.id) {
            return;
        }

        return new Promise(async (resolve, reject) => {
            this.promise = {
                resolve,
                reject,
                running: true
            };
            const {entryTimelines} = this.training.chapters[chapterId];

            this.setUpRestrictionAction(chapterId);

            this.eventLoop.addTimelines(entryTimelines);
            this.clock.start();
            this.training.setStartTime(Date.now());

            if (!window.noserver) {
                const payload = {
                    trainingId: this.training.id,
                    meetingId: wv.effectController.meetingInfo.data.id,
                    report: this.training.registry.getReport()
                };

                const {trainingEvaluationId} = await TrainingService.recordEvaluationReport(payload);
                wv.effectController.meetingInfo.trainingEvaluationId = trainingEvaluationId;
            }
        });
    }

    setUpRestrictionAction(chapterId) {
        const chapter = this.training.chapters[chapterId];
        if (chapter.restrictionAction) {
            const restrictionAction = new LoadTimeline(chapter.restrictionAction);
            document.addEventListener('restricted_mesh_selected', () => restrictionAction.execute(this.eventLoop));
        }
    }

    async stopModule(retainState = false) {
        StepInstructionScreenManager.removeScreen();
        await updateMenuForTraining(false);
        this.clock.stop();
        await this.eventLoop.stop(retainState);
        this.training.end(retainState);
        this.promise.running = false;
        wv.trainingAuthoringEnabled = true;
        document.dispatchEvent(new CustomEvent('training_stopped_abruptly'));
        // get training again after stopping training
        wv.communicator.socket.communicateWithContainer({
            message: "getTrainingData"
        });
    }

    async forceStop() {
        await this.stopModule();
        this.promise.reject("This chapter was forcefully stopped");
    }

    async tick(deltaTime) {
        const isFinished = await this.eventLoop.tick(deltaTime);
        if (isFinished) {
            await this.stopModule();
            return this.promise.resolve("This chapter was finished");
        }
    }
}

export default TrainingPlayer;
